<template>
  <div class="sent-place-form" :class="{'hide-my-place': selectedPromptpaiId !== ''}">
    <div class="loading-animation" v-show="isSending && !sendSuccessfully"></div>
    <div class="complete-animation" v-show="sendSuccessfully"></div>
    <TitleBar :text="$t(`SendPlaceForm.${selectedPromptpaiId === '' ? 'topic1' : 'topic2'}`)" :showIconButton="false" @clickCloseButton="clickCloseButton" v-show="!isSending && !sendSuccessfully" />
    <div class="body" :class="{'hide-my-place': selectedPromptpaiId !== ''}" v-show="!isSending && !sendSuccessfully">
      <div class="user-info">
        <div class="user-profile">
          <img :src="userProfilePath">
        </div>
        <div class="user-name">
          <div class="display-name">{{ displayName }}</div>
          <div class="real-name">{{ firstLastName }}</div>
        </div>
      </div>
      <div class="pp-input">
        <input type="number" :placeholder="$t(`SendPlaceForm.placeholderInput`)" v-model="promptpaiId" @input="limitLength">
        <div class="mini-place-card-container" v-show="showMiniPlaceCard" :class="{'hide-my-place': selectedPromptpaiId !== ''}">
          <MiniPlaceCard class="mini-place-card"
            :categoryIconPath="categoryIconPath"
            :categoryIconHdPath="categoryIconPath2x"
            :code="promptpaiId"
            :nameTh="promptpaiNameTh"
            :nameEn="promptpaiNameEn"
            :clickable="false" />
        </div>
        <button class="reset-input-button" @click="resetInput()" v-show="promptpaiId !== '' && selectedPromptpaiId === ''">
          <img :src="util.getImagePath('x_blue@2x.png')" :srcset="util.getImageSet('x_blue')">
        </button>
      </div>
      <div class="my-place" v-if="selectedPromptpaiId === ''">
        <div class="text">{{ $t(`SendPlaceForm.${isMyPlaces ? 'selectFromMyPlace' : 'selectFromBestPlace'}`) }}</div>
        <div class="filter-my-place" v-if="myPlaceList.length > 0">
          <input type="text" :placeholder="$t('SendPlaceForm.placeholderFilter')" v-model="keyword" autocomplete="off" :style="{'padding-right': keyword === '' ? '25px' : '50px'}">
          <button class="clear-filter-button" @click="clickClearFilterButton" v-show="keyword !== ''">
            <img :src="util.getImagePath('x_blue@2x.png')" :srcset="util.getImageSet('x_blue')">
          </button>
        </div>
        <div class="my-place-list">
          <div class="empty-my-place-list" v-if="filteredMyPlaceList.length <= 0 && !isGettingMyPlaceList">
            {{ $t('SendPlaceForm.notFound') }}
          </div>
          <div class="empty-my-place-list" v-if="isGettingMyPlaceList">
            <div class="loading-animation primary"></div>
          </div>
          <div class="mini-place-card-container" v-for="myPlace in filteredMyPlaceList" :key="myPlace.promptpai_id" @click="selectFromMyPlaceList(myPlace.promptpai_id)">
            <MiniPlaceCard class="mini-place-card"
              :categoryIconPath="myPlace.iconfilename"
              :categoryIconHdPath="myPlace.iconfilename_hd"
              :code="myPlace.promptpai_id"
              :nameTh="myPlace.promptpai_name_th"
              :nameEn="myPlace.promptpai_name_en"
              :clickable="false" />
          </div>
        </div>
      </div>
      <div class="button-list">
        <button class="sent-button" :class="{disable: promptpaiId.length < 8 || !isCorrectPromptpaiId}" @click="clickSentButton" :disabled="promptpaiId.length < 8 || !isCorrectPromptpaiId">
          {{ $t('SendPlaceForm.sendPlace') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import TitleBar from '@/components/TitleBar.vue'
  import MiniPlaceCard from '@/components/MiniPlaceCard.vue'
  import { setTimeout } from 'timers'

  export default {
    name: 'SendTo',
    components: {
      TitleBar,
      MiniPlaceCard
    },
    props: {
      uid: {
        type: String,
        default: ''
      },
      selectedPromptpaiId: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        displayName: '',
        firstLastName: '',
        userProfilePath: '',
        promptpaiId: '',
        promptpaiNameTh: '',
        promptpaiNameEn: '',
        categoryIconPath: '',
        categoryIconPath2x: '',
        showMiniPlaceCard: false,
        myPlaceList: [],
        keyword: '',
        isSending: false,
        sendSuccessfully: false,
        isGettingMyPlaceList: false,
        isMyPlaces: true,
        isCorrectPromptpaiId: false
      }
    },
    mounted () {
      var self = this
      self.getReceiverInfo()
      if (self.selectedPromptpaiId !== '') {
        self.promptpaiId = self.selectedPromptpaiId
        self.limitLength()
      } else {
        self.getMyPlaceList()
      }
    },
    computed: {
      filteredMyPlaceList () {
        var self = this
        return self.myPlaceList.filter(function (myPlace) {
          var isMatchCode = myPlace.promptpai_id.toLowerCase().indexOf(self.keyword.toLowerCase()) !== -1
          var isMatchTh = myPlace.promptpai_name_th.toLowerCase().indexOf(self.keyword.toLowerCase()) !== -1
          var isMatchEn = myPlace.promptpai_name_en.toLowerCase().indexOf(self.keyword.toLowerCase()) !== -1
          var isEmptyKeyword = self.keyword === ''
          return isMatchCode || isMatchTh || isMatchEn || isEmptyKeyword
        })
      }
    },
    methods: {
      clickCloseButton: function () {
        var self = this
        self.$router.back()
      },
      getReceiverInfo () {
        var self = this
        self.pp.getUserInformation(
          self.uid,
          undefined,
          (result) => {
            if (result.status.code === 200) {
              self.displayName = result.data.display_name
              self.firstLastName = `${result.data.profile_firstname} ${result.data.profile_lastname}`
              self.userProfilePath = result.data.profile_picture_fullpath
            } else if (result.status.code === 401) {
              self.loginAgain()
            } else if (result.status.code === 403) {
            } else {
            }
          }
        )
      },
      getMyPlaceList () {
        var self = this
        self.isGettingMyPlaceList = true
        var userProfile = {}
        var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
        var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
        if (isAuthenticated) {
          userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
          uuid = undefined
        }
        self.pp.getFavoritePlaces(
          'name' in userProfile ? userProfile.name : undefined,
          'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
          uuid,
          0,
          undefined,
          undefined,
          (result) => {
            if (result.status.code === 200) {
              self.myPlaceList = result.data
            } else if (result.status.code === 401) {
              self.loginAgain()
            } else if (result.status.code === 403) {
            } else {
            }
            self.isGettingMyPlaceList = false
          }
        )
      },
      clickClearFilterButton () {
        var self = this
        self.keyword = ''
      },
      selectFromMyPlaceList (id) {
        var self = this
        self.promptpaiId = id
        self.limitLength()
      },
      resetInput () {
        var self = this
        if (self.selectedPromptpaiId === '') {
          self.promptpaiId = ''
          self.isCorrectPromptpaiId = false
          self.showMiniPlaceCard = false
        }
      },
      limitLength () {
        var self = this
        self.promptpaiId = self.promptpaiId.replace(/\D/g, '')
        self.promptpaiId = self.promptpaiId.slice(0, 8)
        if (self.promptpaiId.length === 8) {
          self.pp.getPromptpaiDescription(self.promptpaiId, undefined, undefined, undefined, undefined, undefined, function (result) {
            if (result.data.length > 0) {
              self.promptpaiNameTh = result.data[0].promptpai_name_th
              self.promptpaiNameEn = result.data[0].promptpai_name_en
              self.categoryIconPath = result.data[0].iconfilename
              self.categoryIconPath2x = result.data[0].iconfilename_hd
              self.showMiniPlaceCard = true
              self.isCorrectPromptpaiId = true
            } else {
              self.promptpaiId = ''
              self.showMiniPlaceCard = false
              self.isCorrectPromptpaiId = false
            }
          })
        } else {
          self.showMiniPlaceCard = false
          self.promptpaiName = ''
          self.categoryIconPath = ''
        }
      },
      clickSentButton () {
        var self = this
        self.sent()
      },
      sent () {
        var self = this
        if (self.isSending) {
          return
        }
        self.isSending = true
        var userProfile = {}
        var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
        var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
        if (isAuthenticated) {
          userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
          uuid = undefined
        }
        self.pp.sendLocation(
          self.uid,
          self.promptpaiId,
          'name' in userProfile ? userProfile.name : undefined,
          'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
          uuid,
          undefined,
          (result) => {
            if (result.status.code === 200) {
              if (result.data) {
                self.updateRecentList()
                self.sendSuccessfully = true
                setTimeout(() => {
                  self.isSending = false
                  self.sendSuccessfully = false
                  self.$router.back()
                  self.$root.$emit('closeModal')
                }, 1000)
                setTimeout(() => {
                  self.$root.$emit('askForTransfer')
                }, 1300)
              } else {
                self.sendSuccessfully = false
                self.isSending = false
              }
            } else if (result.status.code === 401) {
              self.loginAgain()
              self.sendSuccessfully = false
              self.isSending = false
            } else if (result.status.code === 403) {
              self.sendSuccessfully = false
              self.isSending = false
            } else {
              self.sendSuccessfully = false
              self.isSending = false
            }
          }
        )
      },
      updateRecentList () {
        var self = this
        var userProfile = {}
        var uuid = JSON.parse(self.getPromptPaiCookies('Uuid'))
        var isAuthenticated = JSON.parse(self.getPromptPaiCookies('isAuthenticated'))
        if (isAuthenticated) {
          userProfile = JSON.parse(self.getPromptPaiCookies('UserProfile'))
          uuid = undefined
        }
        self.setRecentPage(1)
        self.pp.getRecentPlaces(
          'name' in userProfile ? userProfile.name : undefined,
          'longdousertoken' in userProfile ? userProfile.longdousertoken : undefined,
          uuid,
          self.itemsPerPage,
          'all',
          self.itemsPerPage * (self.recentPage - 1),
          undefined,
          (result) => {
            if (result.status.code === 200) {
              self.setRecentList(result.data)
            } else if (result.status.code === 401) {
              self.loginAgain()
            } else if (result.status.code === 403) {
            } else {
            }
          }
        )
      }
    }
  }
</script>

<style scoped>
  .sent-place-form {
    width: 480px;
    height: 75%;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    margin-top: auto;
    margin-bottom: auto;
  }

  .sent-place-form.hide-my-place {
    height: calc(50px + 50px + 96px + 64px);
  }

  .body {
    height: calc(100% - 50px);
    box-sizing: border-box;
    background: rgb(255, 255, 255);
    position: relative;
  }

  .body.hide-my-place {
    height: calc(50px + 96px + 64px);
  }

  .user-info {
    background: rgb(34, 84, 156);
    height: 50px;
    display: flex;
    flex-direction: row;
    padding: 0px 16px;
  }

  .user-profile {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 100%;
  }

  .user-profile > img {
    width: 32px;
    height: 32px;
  }

  .user-name {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0px 0px 0px 16px;
  }

  .display-name {
    color: rgb(255, 255, 255);
    font-size: 18px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: 1.75;
  }

  .real-name {
    color: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
    justify-content: center;
    line-height: 1.75;
  }

  .pp-input {
    height: fit-content;
    padding: 12px 16px 16px 16px;
    position: relative;
    background-color: rgb(34, 84, 156);
    box-shadow: 0px 4px 4px -4px rgba(0, 0, 0, 0.4);
    -webkit-appearance: none;
  }

  .pp-input > input {
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 0px 4px 0 rgba(0, 0, 0, 0.4);
    -webkit-appearance: none;
    border-radius: 8px;
    border: none;
    height: 68px;
    width: 100%;
    text-align: center;
    font-family: Default-PromptPai;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 18px;
    outline: none;
    padding: 0px;
    -webkit-appearance: none;
  }

  .pp-input > input[type="number"]::-webkit-outer-spin-button,
  .pp-input > input[type="number"]::-webkit-inner-spin-button,
  .pp-input > input[type="number"]::-webkit-outer-spin-button,
  .pp-input > input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .pp-input > input[type="number"],
  .pp-input > input[type="number"] {
    -moz-appearance: textfield;
  }

  .pp-input > input::-webkit-input-placeholder {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 18px;
    color: rgb(120, 120, 120);
    font-family: Prompt;
  }

  .pp-input > .mini-place-card-container {
    position: absolute;
    height: 68px;
    width: calc(100% - 32px - 68px);
    top: 12px;
    border-radius: 8px;
    background: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .pp-input > .mini-place-card-container.hide-my-place {
    width: calc(100% - 32px);
  }

  button.reset-input-button {
    position: absolute;
    top: 12px;
    right: 16px;
    border: none;
    background-color: transparent;
    height: 68px;
    width: 68px;
    cursor: pointer;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
  }

  button.reset-input-button > img {
    width: 24px;
    height: 24px;
  }

  .my-place {
    height: calc(100% - 50px - 96px - 64px);
  }

  .my-place > .text {
    font-size: 18px;
    padding: 16px 16px 8px 16px;
    font-family: Prompt;
    font-weight: bold;
  }

  .my-place > .filter-my-place {
    padding: 0px 16px;
    position: relative;
  }

  .filter-my-place > input {
    width: 100%;
    height: 50px;
    border-radius: 25px;
    border: none;
    padding: 0px 50px 0px 25px;
    margin: 0px;
    box-shadow: 0px 0px 4px 0 rgba(0, 0, 0, 0.4);
    -webkit-appearance: none;
    font-family: Default-PromptPai;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 18px;
    box-sizing: border-box;
  }

  .filter-my-place > input::-webkit-input-placeholder {
    font-size: 18px;
    font-family: Prompt;
    color: rgb(120, 120, 120);
  }

  .filter-my-place > button.clear-filter-button {
    position: absolute;
    top: 0px;
    right: 16px;
    border: none;
    background-color: transparent;
    height: 50px;
    width: 50px;
    cursor: pointer;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
  }

  .filter-my-place > button.clear-filter-button > img {
    width: 24px;
    height: 24px;
  }

  .my-place-list {
    overflow-y: auto;
    height: calc(100% - 54px - 50px - 32px);
    margin: 16px;
  }

  .my-place-list::-webkit-scrollbar-button {
    height: 12.5px;
  }
  .my-place-list::-webkit-scrollbar {
    background-color: rgb(251, 251, 251);
  }
  .my-place-list::-webkit-scrollbar-thumb {
    border: 2px solid rgb(251, 251, 251);
  }

  .my-place-list > .mini-place-card-container {
    cursor: pointer;
    border-bottom: 1px solid rgb(227, 227, 227);
    padding: 4px 0px 8px 0px;
  }

  .empty-my-place-list {
    font-size: 24px;
    color: rgb(120, 120, 120);
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .button-list {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    position: absolute;
    bottom: 0px;
    width: 100%;
    background-image: rgb(255, 255, 255);
    box-shadow: 0px -4px 4px -4px rgba(0, 0, 0, 0.4);
    -webkit-appearance: none;
  }

  button.sent-button {
    border: none;
    background-image: linear-gradient(-180deg, rgb(245, 166, 35) 0%, rgb(251, 147, 73) 100%);
    border-radius: 24px;
    color: rgb(255, 255, 255);
    height: 48px;
    padding: 0px 24px;
    box-sizing: border-box;
    font-family: Prompt;
    font-size: 18px;
    width: calc(100% - 16px);
    margin: 8px 0px;
    cursor: pointer;
  }

  button.sent-button.disable {
    background-image: linear-gradient(-180deg, rgb(120, 120, 120) 0%, rgb(120, 120, 120) 100%);
  }

  @media only screen and (max-width: 768px) {
    .sent-place-form {
      width: 100%;
      min-width: 320px;
      height: 100%;
      border-radius: 0px;
    }

    .sent-place-form.hide-my-place {
      max-width: calc(100% - 20px);
      min-width: calc(100% - 20px);
      height: calc(50px + 50px + 96px + 64px);
      border-radius: 10px;
    }

    .body {
      height: calc(100% - 50px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SendPlaceForm.vue